import heroFoto1 from '../assets/fotos-carrosel-otimizadas/foto-carrossel-full.jpg';
import heroFoto2 from '../assets/fotos-carrosel-otimizadas/foto-carrossel2-full.jpg';
import heroFoto3 from '../assets/fotos-carrosel-otimizadas/foto-carrossel3-full.jpg';
import heroFoto4 from '../assets/fotos-carrosel-otimizadas/foto-carrossel4-full.jpg';
import heroFoto5 from '../assets/fotos-carrosel-otimizadas/foto-carrossel5-full.jpg';
import heroFoto6 from '../assets/fotos-carrosel-otimizadas/foto-carrossel6-full.jpg';

import heroFoto1Thumb from '../assets/fotos-carrosel-otimizadas/foto-carrossel-thumb.jpg';
import heroFoto2Thumb from '../assets/fotos-carrosel-otimizadas/foto-carrossel2-thumb.jpg';
import heroFoto3Thumb from '../assets/fotos-carrosel-otimizadas/foto-carrossel3-thumb.jpg';
import heroFoto4Thumb from '../assets/fotos-carrosel-otimizadas/foto-carrossel4-thumb.jpg';
import heroFoto5Thumb from '../assets/fotos-carrosel-otimizadas/foto-carrossel5-thumb.jpg';

import galeriaFoto1Thumb from '../assets/fotos-carrosel-otimizadas/20250624_150622013_iOS-thumb.jpg';
import galeriaFoto1Full from '../assets/fotos-carrosel-otimizadas/20250624_150622013_iOS-full.jpg';
import galeriaFoto2Thumb from '../assets/fotos-carrosel-otimizadas/20250813_204932790_iOS-thumb.jpg';
import galeriaFoto2Full from '../assets/fotos-carrosel-otimizadas/20250813_204932790_iOS-full.jpg';
import galeriaFoto3Thumb from '../assets/fotos-carrosel-otimizadas/20251119_134121815_iOS-thumb.jpg';
import galeriaFoto3Full from '../assets/fotos-carrosel-otimizadas/20251119_134121815_iOS-full.jpg';
import galeriaFoto4Thumb from '../assets/fotos-carrosel-otimizadas/20260202_214703834_iOS-thumb.jpg';
import galeriaFoto4Full from '../assets/fotos-carrosel-otimizadas/20260202_214703834_iOS-full.jpg';
import galeriaFoto5Thumb from '../assets/fotos-carrosel-otimizadas/20260415_215922991_iOS-thumb.jpg';
import galeriaFoto5Full from '../assets/fotos-carrosel-otimizadas/20260415_215922991_iOS-full.jpg';
import galeriaFoto6Thumb from '../assets/fotos-carrosel-otimizadas/20260728_013509922_iOS-thumb.jpg';
import galeriaFoto6Full from '../assets/fotos-carrosel-otimizadas/20260728_013509922_iOS-full.jpg';
import galeriaFoto7Thumb from '../assets/fotos-carrosel-otimizadas/20260801_200102796_iOS-thumb.jpg';
import galeriaFoto7Full from '../assets/fotos-carrosel-otimizadas/20260801_200102796_iOS-full.jpg';
import galeriaFoto8Thumb from '../assets/fotos-carrosel-otimizadas/20260801_202940494_iOS-thumb.jpg';
import galeriaFoto8Full from '../assets/fotos-carrosel-otimizadas/20260801_202940494_iOS-full.jpg';
import galeriaFoto9Thumb from '../assets/fotos-carrosel-otimizadas/20260804_124747459_iOS-thumb.jpg';
import galeriaFoto9Full from '../assets/fotos-carrosel-otimizadas/20260804_124747459_iOS-full.jpg';
import galeriaFoto10Thumb from '../assets/fotos-carrosel-otimizadas/20260821_201941453_iOS-thumb.jpg';
import galeriaFoto10Full from '../assets/fotos-carrosel-otimizadas/20260821_201941453_iOS-full.jpg';
import galeriaFoto11Thumb from '../assets/fotos-carrosel-otimizadas/IMG_2152-thumb.jpg';
import galeriaFoto11Full from '../assets/fotos-carrosel-otimizadas/IMG_2152-full.jpg';

// Cores e estilos
export const COLORS = {
  azul: '#0C0CF2',
  escuro: '#00051C',
  medio: '#3D7CF2',
  claro: '#9DBBF2',
  verde: '#79F2A8',
  fundo: '#F7F9FF',
  branco: '#fff',
  cinza: '#4A5163',
  borda: '#E3EAFB',
};

export const URLS = {
  whatsapp: 'https://wa.me/5532998480553?text=Gostaria%20de%20entender%20meus%20n%C3%BAmeros%2C%20podemos%20agendar%20uma%20sess%C3%A3o%20estrat%C3%A9gica%3F',
  website: 'https://pranaconsultoria.com',
  email: '(32) 99848-0553',
  location: 'Juiz de Fora, MG',
};

export const COMPANY_INFO = {
  name: 'Prana Consultoria',
  founder: 'Kássio',
  tagline: 'com você até funcionar',
  description: 'Donos de verdade. Resultados de verdade.',
  phone: '(32) 99848-0553',
};

export const HERO_IMAGES = [
  {
    src: heroFoto1,
    alt: 'Consultores da Prana com a equipe do Acallento Café e Doce na frente da cafeteria',
    priority: true,
  },
  {
    src: heroFoto2,
    alt: 'Consultores da Prana com a equipe da clínica ImplanTOP na recepção',
  },
  {
    src: heroFoto3,
    alt: 'Equipe do cliente reunida diante do quadro com o fluxo de venda, compras e produção',
  },
  {
    src: heroFoto4,
    alt: 'Consultores da Prana com os donos na porta da panificadora Esquina do Pão',
  },
  {
    src: heroFoto5,
    alt: 'Consultores da Prana com a equipe na Lavanderia Moreira',
  },
  {
    src: heroFoto6,
    alt: 'Consultor da Prana conduzindo reunião de gestão com a equipe do cliente',
  },
];

export const GALLERY_ITEMS = [
  {
    id: 0,
    full: galeriaFoto1Full,
    thumb: galeriaFoto1Thumb,
    alt: 'Consultores da Prana em planejamento com o cliente, com anotações no flip chart e notebook aberto',
    caption: 'Rodada de planejamento com o cliente',
  },
  {
    id: 1,
    full: galeriaFoto2Full,
    thumb: galeriaFoto2Thumb,
    alt: 'Consultores da Prana reunidos com o time do cliente ao redor da mesa, notebook aberto com planilha',
    caption: 'Rodada de acompanhamento no salão do cliente',
  },
  {
    id: 2,
    full: galeriaFoto3Full,
    thumb: galeriaFoto3Thumb,
    alt: 'Consultoras da Prana em reunião de trabalho numa cafeteria, com notebook e café na mesa',
    caption: 'Alinhamento estratégico fora do escritório',
  },
  {
    id: 3,
    full: galeriaFoto4Full,
    thumb: galeriaFoto4Thumb,
    alt: 'Consultores da Prana em reunião de acompanhamento num espaço colaborativo, com notebook e celular',
    caption: 'Acompanhamento em espaço colaborativo',
  },
  {
    id: 4,
    full: galeriaFoto5Full,
    thumb: galeriaFoto5Thumb,
    alt: 'Consultores da Prana em visita a um espaço empresarial do cliente',
    caption: 'Prana em campo',
  },
  {
    id: 5,
    full: galeriaFoto6Full,
    thumb: galeriaFoto6Thumb,
    alt: 'Reunião remota de acompanhamento por videochamada com a equipe da Prana',
    caption: 'Acompanhamento remoto com o time',
  },
  {
    id: 6,
    full: galeriaFoto7Full,
    thumb: galeriaFoto7Thumb,
    alt: 'Consultor da Prana analisando dados em múltiplos monitores antes da rodada com o cliente',
    caption: 'Preparação da rodada, número por número',
  },
  {
    id: 7,
    full: galeriaFoto8Full,
    thumb: galeriaFoto8Thumb,
    alt: 'Consultor da Prana trabalhando em home office com notebook e monitor',
    caption: 'Trabalho de análise antes da reunião',
  },
  {
    id: 8,
    full: galeriaFoto9Full,
    thumb: galeriaFoto9Thumb,
    alt: 'Equipe reunida em sala de reunião com dados e indicadores exibidos na tela',
    caption: 'Reunião de gestão com os números na tela',
  },
  {
    id: 9,
    full: galeriaFoto10Full,
    thumb: galeriaFoto10Thumb,
    alt: 'Consultor da Prana acompanhando dashboard de atendimento e vendas em videochamada com o cliente',
    caption: 'Acompanhamento de indicadores de atendimento',
  },
  {
    id: 10,
    full: galeriaFoto11Full,
    thumb: galeriaFoto11Thumb,
    alt: 'Dois consultores da Prana no carro, a caminho de um atendimento',
    caption: 'Estrada: a caminho do próximo cliente',
  },
  {
    id: 11,
    full: heroFoto1,
    thumb: heroFoto1Thumb,
    alt: 'Consultores da Prana com a equipe do Acallento Café e Doce na frente da cafeteria',
    caption: 'Acallento Café & Doce · time reunido na loja',
  },
  {
    id: 12,
    full: heroFoto2,
    thumb: heroFoto2Thumb,
    alt: 'Consultores da Prana com a equipe da clínica ImplanTOP na recepção',
    caption: 'ImplanTOP Odontologia · visita à clínica',
  },
  {
    id: 13,
    full: heroFoto3,
    thumb: heroFoto3Thumb,
    alt: 'Equipe do cliente reunida diante do quadro com o fluxo de venda, compras e produção',
    caption: 'Mapeamento de processo com o time inteiro',
  },
  {
    id: 14,
    full: heroFoto4,
    thumb: heroFoto4Thumb,
    alt: 'Consultores da Prana com os donos na porta da panificadora Esquina do Pão',
    caption: 'Esquina do Pão · panificadora',
  },
  {
    id: 15,
    full: heroFoto5,
    thumb: heroFoto5Thumb,
    alt: 'Consultores da Prana com a equipe na Lavanderia Moreira',
    caption: 'Lavanderia Moreira · visita à operação',
  },
];
